export interface NotificationItem {
    uuid: string;
    title: string;
    message: string;
    path?: string;
    read?: boolean;
    createdOnTs?: string | Date;
    messageUser?: { uuid?: string; name?: string };
    notificationTypeCode?: string;
}

const TRANSLATION_KEY_PATTERN = /^[a-z0-9_-]+\.[a-z0-9_.-]+$/i;

export const resolveNotificationTitle = (title: string, translate: (key: string) => string): string => {
    if (!title) {
        return "";
    }
    return TRANSLATION_KEY_PATTERN.test(title) ? translate(title) : title;
};

const NOTIFICATION_LINK_PAGE_TYPE_CODES = new Set(["CONFMSG", "CONFSUB"]);
const NOTIFICATION_LINK_ALERT_TYPE_CODES = new Set(["ALERTTRG"]);

export const isConfidentialShareNotification = (notification: NotificationItem): boolean =>
    notification.notificationTypeCode === "CONFMSG"
    || notification.notificationTypeCode === "CONFSUB"
    || notification.path?.startsWith("/share/")
    || notification.path?.startsWith("/#/share/")
    || notification.title === "Vertrouwelijke link bekeken";

export const resolveNotificationLinkLabelKey = (notification: NotificationItem): string => {
    const typeCode = notification.notificationTypeCode?.trim().toUpperCase();
    if (typeCode && NOTIFICATION_LINK_PAGE_TYPE_CODES.has(typeCode)) {
        return "notification.link.page";
    }
    if (typeCode && NOTIFICATION_LINK_ALERT_TYPE_CODES.has(typeCode)) {
        return "notification.link.alert";
    }
    if (isConfidentialShareNotification(notification)) {
        return "notification.link.page";
    }
    const path = normalizeNotificationNavigatePath(notification.path);
    if (path?.startsWith("/alerts/")) {
        return "notification.link.alert";
    }
    return "notification.link";
};

/** HashRouter: paths must be like `/share/...`, not `/#/share/...` (avoids `#/#/share/...`). */
export const normalizeNotificationNavigatePath = (path: string | undefined): string | undefined => {
    if (!path) {
        return path;
    }
    if (path.startsWith("/#/")) {
        return path.slice(2) || "/";
    }
    return path;
};

export const isCommentStyleNotification = (notification: NotificationItem): boolean =>
    !isConfidentialShareNotification(notification) && Boolean(notification.messageUser?.name);

export const isHtmlMessage = (message: string): boolean => /<[^>]+>/.test(message ?? "");
